module.exports = __webpack_public_path__ + "img/home-hero.f03600d.webp";